/* Ebukurty size chart: convert cm tables to dual in/cm for US shoppers */
(function () {
  var FACTOR = 2.54;
  function toIn(n) {
    return Math.round((n / FACTOR) * 10) / 10;
  }
  function parseCell(text) {
    var t = (text || '').trim();
    if (!t) return null;
    // ranges like 64-98 or 64–98
    var m = t.match(/^(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)$/);
    if (m) {
      return { kind: 'range', a: parseFloat(m[1]), b: parseFloat(m[2]), raw: t };
    }
    if (/^\d+(?:\.\d+)?$/.test(t)) {
      return { kind: 'num', a: parseFloat(t), raw: t };
    }
    return null;
  }
  function formatDual(parsed, mode) {
    if (!parsed) return null;
    if (parsed.kind === 'range') {
      var aIn = toIn(parsed.a), bIn = toIn(parsed.b);
      if (mode === 'in') return aIn + '–' + bIn + ' in';
      if (mode === 'cm') return parsed.a + '–' + parsed.b + ' cm';
      return '<span class="ebukurty-size-dual"><span class="ebukurty-in">' + aIn + '–' + bIn + ' in</span> <span class="ebukurty-cm">(' + parsed.a + '–' + parsed.b + ' cm)</span></span>';
    }
    var inch = toIn(parsed.a);
    if (mode === 'in') return inch + ' in';
    if (mode === 'cm') return parsed.a + ' cm';
    return '<span class="ebukurty-size-dual"><span class="ebukurty-in">' + inch + ' in</span> <span class="ebukurty-cm">(' + parsed.a + ' cm)</span></span>';
  }
  function enhanceChart(wrap) {
    if (wrap.getAttribute('data-ebukurty-enhanced') === '1') return;
    var table = wrap.querySelector('table');
    if (!table) return;
    wrap.setAttribute('data-ebukurty-enhanced', '1');
    var caption = table.querySelector('caption');
    if (caption) {
      caption.textContent = 'Garment measurements — inches (in) with centimeters (cm)';
    }
    var cells = table.querySelectorAll('tbody td');
    cells.forEach(function (td) {
      var parsed = parseCell(td.textContent);
      if (!parsed) return;
      td.setAttribute('data-cm-raw', parsed.raw);
      td.innerHTML = formatDual(parsed, 'dual');
    });
    // unit toggle
    var toggle = document.createElement('div');
    toggle.className = 'ebukurty-size-unit-toggle';
    toggle.innerHTML = '<button type="button" data-mode="dual" aria-pressed="true">in + cm</button>' +
      '<button type="button" data-mode="in" aria-pressed="false">in</button>' +
      '<button type="button" data-mode="cm" aria-pressed="false">cm</button>';
    wrap.insertBefore(toggle, table);
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-mode]');
      if (!btn) return;
      var mode = btn.getAttribute('data-mode');
      toggle.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      cells.forEach(function (td) {
        var raw = td.getAttribute('data-cm-raw');
        if (!raw) return;
        var parsed = parseCell(raw);
        var html = formatDual(parsed, mode);
        if (html) td.innerHTML = html;
      });
      if (caption) {
        if (mode === 'in') caption.textContent = 'Garment measurements in inches (in)';
        else if (mode === 'cm') caption.textContent = 'Garment measurements in centimeters (cm)';
        else caption.textContent = 'Garment measurements — inches (in) with centimeters (cm)';
      }
    });
  }
  function run() {
    document.querySelectorAll('.ebukurty-garment-size-chart').forEach(enhanceChart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
